import React from 'react';
import './Spinner.css';

const Spinner = ({color}) => {
  return (
    <div className="spinner-container">
      <div style={{color: color || "black"}} className="spinner"></div>
    </div>
  );
};

export default Spinner;
